<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'addexception'+order.id">
      <slot></slot>
    </span>
    <el-dialog top="0vh" v-if="dialogFormVisible" class="el-dialog-sm custom-dialog" :close-on-click-modal="false" 
    :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="init()">
      <div :class="{mobile_upload_order:mobiletype}">
        <div :class="{mobile_upload_order:mobiletype}">
          <h3 class="text-center"><i v-if="step > 1" class="el-icon-arrow-left back" @click="backstep"></i>{{ step<4?'新增'+title:'确认'+title }}</h3>
          <ul class="error-messages" v-if="!isEmptyErrors">
            <li v-for="error in errors">{{error[0].message}}</li>
          </ul>
          <div v-if="step==1">
            <div class="select-all" style="margin-bottom:16px;">
              <el-col :span="12">
                <div class="expressBtn all" :class="{is_active:curType==1}" @click="curType=1">异常/通知</div>
              </el-col>
              <el-col :span="12">
                <div class="expressBtn notAll" :class="{is_active:curType==2}" @click="curType=2">提示</div>
              </el-col>
            </div>
            <template v-if="curType==1">
              <div style="display: flex;justify-content: space-between;">
                <div style="width:49%;">
                  <div class="type-rows" style="border-bottom:1px solid #d7d7d7">异常</div>
                  <div class="type-rows" v-for="(res,index) in exceptionTypes.filter(i=>i.category==1)">
                    <el-radio v-model="form.exception_id" :label="res.value">{{res.content}}</el-radio>
                  </div>
                </div>
                <div style="width:49%;">
                  <div class="type-rows" style="border-bottom:1px solid #d7d7d7">通知</div>
                  <div class="type-rows" v-for="(res,index) in exceptionTypes.filter(i=>i.category==4)">
                    <el-radio v-model="form.exception_id" :label="res.value">{{res.content}}</el-radio>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div style="display: flex;justify-content: space-between;">
                <div style="width:49%;">
                  <div class="type-rows" style="border-bottom:1px solid #d7d7d7">内部提示</div>
                  <div class="type-rows" v-for="(res,index) in exceptionTypes.filter(i=>i.category==2)">
                    <el-radio v-model="form.exception_id" :label="res.value">{{res.content}}</el-radio>
                  </div>
                </div>
                <div style="width:49%;">
                  <div class="type-rows" style="border-bottom:1px solid #d7d7d7">客户提示</div>
                  <div class="type-rows" v-for="(res,index) in exceptionTypes.filter(i=>i.category==3)">
                    <el-radio v-model="form.exception_id" :label="res.value">{{res.content}}</el-radio>
                  </div>
                </div>
              </div>
            </template>
            <el-button style="margin: 16px 0 20px;" class="block" :type="'primary'" @click="next">下一步</el-button>
          </div>
          <div v-if="step==2">
            <el-row class="select-address" style="border-bottom: none;">
              <el-col :span="24" class="tip">
                选择商品 
              </el-col>
            </el-row>
            <ProductList :groupOrderLine="groupOrderLine" @checkNext="canNext()"
              :order="order" :numEditable="true" :operation="exception_type_name(exceptionTypes.filter(i=>i.value==form.exception_id)[0].category)"
              :need_input_price="order.type==2"></ProductList>
              <el-button style="margin: 20px 0 20px;" class="block" :type="'primary'" @click="next">下一步</el-button>
          </div>
          <div v-if="step==3">
            <el-row class="select-address" style="border-bottom: none;">
              <el-col :span="24" class="tip">
                详情(必填)
              </el-col>
            </el-row>
            <el-input type="textarea" :rows="3" v-model="form.exception_desc"></el-input>
            <el-button style="margin: 20px 0 20px;" class="block" :type="'primary'" @click="next">下一步</el-button>
          </div>
          <div v-if="step==4">
            <div class="ex-row">
              {{ exceptionTypes.filter(i=>i.value==form.exception_id)[0].content }} 
            </div>
            <div class="ex-row" v-if="exceptionTypes.filter(i=>i.value==form.exception_id)[0].need_select_product=='Y'">
              <div style="line-height: inherit;">
                <ProductList :groupOrderLine="groupOrderLine" :checkDisabled="true"
                :order="order" :numEditable="false" :operation="'异常'"></ProductList>
              </div>
            </div>
            <div class="ex-row" style="line-height:30px">
              {{ form.exception_desc }}
            </div>
            <div class="ex-row" style="line-height:30px" v-if="exceptionTypes.filter(i=>i.value==form.exception_id)[0].category==1">
              短信通知{{ clientName }}：{{ exceptionTemplateList.find(i=>i.value==currentTemplate).content.replace('{1}',order.order_no).replace('{2}',exceptionTypes.filter(i=>i.value==form.exception_id)[0].content!='通知'?exceptionTypes.filter(i=>i.value==form.exception_id)[0].content:'')}}
            </div>
            <div class="ex-row" style="line-height:30px;display:flex;" v-if="exceptionTypes.filter(i=>i.value==form.exception_id)[0].category==4">
              <el-checkbox v-model="need_send_sms">
              </el-checkbox>
              <div style="margin-left:10px;">
                短信通知{{ clientName }}：{{ exceptionTemplateList.find(i=>i.value==currentTemplate).content.replace('{1}',order.order_no).replace('{2}',exceptionTypes.filter(i=>i.value==form.exception_id)[0].content!='通知'?exceptionTypes.filter(i=>i.value==form.exception_id)[0].content:'')}}
              </div>
            </div>
            <div>
              <el-button :loading="isSubmitting" style="margin: 20px 0 10px;" class="block" type="info" @click="submit(false)">提交</el-button>
            </div>
            <!--<div>
              <el-button :loading="isSubmitting" style="margin: 10px 0" class="block" :type="'primary'" @click="submit(true)">提交并创建工单</el-button>
            </div>-->
          </div>
        </div> 
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../../services/api.js'
import YueDanIpt from '../../../../components/YueDanIpt'
import ProductList from './ExceptionProductList'
import {errorMessage} from '../../../../services/error.js'
let _ = require('lodash')

export default {
  name: 'Exception',
  props: ['order', 'mobiletype','addExcetion','exceptionTypes','exceptionCategories','exceptionTemplateList'],
  components: {
    YueDanIpt: YueDanIpt,
    ProductList
  },
  computed: {
    title(){
      if(this.step==1)
        return '异常/提示'
      else{
        let t=this.exceptionTypes.filter(i=>i.value==this.form.exception_id)
        if(t.length){
          return this.exception_type_name(t[0].category)
        }
      }
    },
    clientName(){
      let t=this.exceptionTypes.filter(i=>i.value==this.form.exception_id)
      if(t.length){
        return t[0].target_role_list.map((i)=>{
          switch(i.value){
            case 1:
              return this.order.buyer_username;
            case 2:
              return this.order.transport_shipping_username;
            case 3:
              return this.order.buyer_delegate_username;
          }
        }).join(',')
      }
      else
        return ''
    }
  },
  data () {
    return {
      curType:1,
      dialogFormVisible:false,
      isEmptyErrors: true,
      errors: null,
      need_send_sms:false,
      form: {
        exception_id: '',
        exception_desc:'',
      },
      account_id:this.$localStorage.get('account_id'),
      loading: false,
      step:1,
      rules: {
        business_order_no: [
          // { required: true, message: '商家订单号是必填项', trigger: 'blur' }
        ]
      },
      isSubmitting:false,
      canGoStep2:true,
      currentTemplate:{}
    }
  },
  methods: {
    exception_type_name(t){
      switch(t){
        case 1:
          return '异常';
        case 4:
          return '通知';
        default:
          return '提示';
      }
    },
    backstep(){
      if(this.exceptionTypes.filter(i=>i.value==this.form.exception_id)[0].need_select_product=='N' && this.step==3)
        this.step=this.step-2
      else
        this.step--
    },
    canNext(){
        this.canGoStep2=this.groupOrderLine.filter(i=>i.checked).length       
    },
    async show () {
        this.step=1
        this.goods_info = [
          { image: '', remark: '', id: new Date().getTime() }
        ]
        this.dialogFormVisible = true
        this.$store.commit('updateOpenDialog', true) 
        this.groupOrderLine = []
        _.each(this.order.goods_list, item => {
          item.checked = true
          item.selectNum=Number(item.number)
          this.groupOrderLine.push(item)        
        })
    },
    init () {
      this.form.exception_id = ''
      this.errors = null
      this.isEmptyErrors = true
      this.$store.commit('updateOpenDialog', false)
    },
    next(){
      let valid=true;
      this.isEmptyErrors=true;
      this.errors=null;
      switch(this.step){
        case 1:
          if(!this.form.exception_id){
            this.isEmptyErrors = false
            let ex = this.exceptionTypes.filter(i=>i.value==this.form.exception_id)[0];
            this.errors = {
              business_name: [
                {message: '请选择'+this.exception_type_name(ex.category)+'类型'}
              ]
            }
            valid=false;
          }
          else{
            /*let o = this.exceptionTypes.filter(i=>i.value==this.form.exception_id)[0];
            if(o.category==4)
              this.need_send_sms=false*/
            let o = this.exceptionTypes.filter(i=>i.value==this.form.exception_id)[0]
            //console.log('log',o,this.exceptionCategories)
            this.currentTemplate = this.exceptionCategories.find(i=>i.value==o.category).sms_template_number
            //console.log('log2',this.currentTemplate)
            if(valid && o.need_select_product=='N')
              this.step++
          }
          break;
        case 2:
          if(!this.canGoStep2){
            this.isEmptyErrors = false
            this.errors = {
              business_name: [
                {message: '请至少选择一件商品'}
              ]
            }
            valid=false
          }
          break;
        case 3:
          if(!this.form.exception_desc){
            this.isEmptyErrors = false
            let ex = this.exceptionTypes.filter(i=>i.value==this.form.exception_id)[0]
            this.errors = {
              business_name: [
                {message: '请填写'+this.exception_type_name(ex.category)+'描述'}
              ]
            }
            valid=false;
          }
          break;
      }
      if(valid)
        this.step++
    },
    async submit(createTicket) {
          this.isEmptyErrors=true;
          this.errors=null
          this.isSubmitting=true  
          let data={
              order_id: this.order.id,
              type:this.form.exception_id,
              description:this.form.exception_desc,
              sms_template_number:this.currentTemplate
            }
            let o = this.exceptionTypes.filter(i=>i.value==this.form.exception_id)[0]
            if(o.category==1){
              data.need_send_sms='Y'
            }
            else if(o.category==4){
              data.need_send_sms=this.need_send_sms?'Y':'N'
            }
            else
              data.need_send_sms='N'
            data.product_list=[]
            if(o.need_select_product=='Y'){
              _.each(this.groupOrderLine, line => {
                if (line.checked) {
                  let spec={}
                  try{
                    spec=JSON.parse(line.spec)
                  }
                  catch(error){
                    spec=''
                  }
                  data.product_list.push({ id: line.id, number: line.selectNum,  specification:spec});
                }
              })
            }
          let res = await api.post(this, {
            path: 'order_exception.php',
            api: 'add',
            data: data,
            loading: 'loading'
          })
          res = res.body
          this.isSubmitting=false
          if (res.status == 'ok') {
            this.dialogFormVisible = false           
            this.order.exception_list=res.result
            this.order.update_time=this.order.exception_list[0].update_time
            this.$emit('refreshEXList')
            if(createTicket)
              this.$emit('createTicket')
            else
              this.$store.commit('updateMessageDialog', {visible:true,message:'提交成功'})
          }
          else{
            this.isEmptyErrors=false;
            this.errors = {
              business_name: [
                {message: errorMessage[res.result]}
              ]
            }
            this.$forceUpdate()
          }
      /*if(this.form.business_order_no){
        let reg = /[a-zA-Z0-9\-\.\_]+\b$/
        // let d = this.form.business_order_no
        if(!reg.test(this.form.business_order_no) || this.form.business_order_no.length >= 101){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的商家订单号,必须包含字母或数字,可以包含-,_和.,不超过100个字符'}
            ]
          }
          return
        }
      }
      
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors

        if (valid) {
          
        } else {
          return false
        }
      })*/
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .select-all {
  overflow: hidden;
  border-radius: 3px;
  .expressBtn{
    text-align: center;
    display: inline-block;
    border: 1px solid #ccc;
    box-sizing: border-box;
    width: 100%;
    padding: 15px 0;
    cursor: pointer;
    &.is_active{
      background-color: #333;
      border: 1px solid transparent;
      color: #fff;
    }
    &.all {
      border-right: none;
    }
    &.notAll{
      border-left: none;
    }
  }
}
  .dialog-form {
    padding-bottom: 20px;
  }
  .tip {
    font-size: 12px;
    color: #888888;
    line-height: 16px;
  }
  .mobile_upload_order {
    padding: 0 10px !important;
  }
  .clearHistory{
    float: right;
    padding:0;
    font-size: 14px;
    color:#1066CF;
  }
  .ex-row{
    margin-bottom:10px;
  }
  .type-rows{
    line-height: 40px;
  }
  .select-address{
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
  }
  .tip{
    font-size: 16px;
    color: #888888;
    line-height: 24px;
    margin-bottom: 5px;
  }
  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }
  .error-messages {
    display: block;
    background-color: #fff1f1;
    padding: 10px;
    text-align: center;
    color: #ff4650;
    line-height: 17px;
    margin-bottom: 10px;
    border-radius: 5px;

    li {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/single/AddException.vue